import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  card: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "1rem",
    backgroundColor: "var(--app-surface)",
    borderRadius: "10px",
    border: "1px solid var(--app-border)",
    cursor: "pointer",
  },
  titleIndicator: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  loaderStyling: {
    display: "block",
    margin: "0 auto",
  },
  setupBtn: {
    padding: "12px 20px !important",
    borderRadius: "8px !important",
    border: "1px solid var(--app-primary) !important",
    backgroundColor: "var(--app-primary) !important",
    height: "44px !important",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05) !important",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    fontFamily: "Inter !important",
    color: "var(--app-on-primary) !important",
    "&:hover": {
      backgroundColor: "var(--app-primary) !important",
      opacity: "0.8 !important",
    },
  },
  cancelBtn: {
    padding: "12px 20px !important",
    borderRadius: "8px !important",
    border: "1px solid var(--app-border) !important",
    backgroundColor: "var(--app-surface-2) !important",
    height: "44px !important",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05) !important",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    fontFamily: "Inter !important",
    color: "var(--app-text) !important",
    "&:hover": {
      backgroundColor: "var(--app-surface-2) !important",
      opacity: "0.8 !important",
    },
  },
}));

export default useStyles;
